import { chat } from '../../stores/chat';
import { ChatSocket } from '../../hooks/use-socket';
import { ChatDelete } from '../../types/bingo-events/in/chat/delete';

const DELETE_ANIMATION_MS = 750;

export const onDelete = (socket: ChatSocket) => {
    const callback = (response: ChatDelete) => {
        chat.messages.set((messages) =>
            messages.map((m) =>
                m.messageId === response.messageId
                    ? { ...m, pendingDelete: true }
                    : m
            )
        );

        setTimeout(() => {
            chat.messages.set((messages) =>
                messages.filter((m) => m.messageId !== response.messageId)
            );

            if (response.message.trim()) {
                chat.messages.merge([
                    {
                        message: response.message,
                        isSystemMsg: true,
                        isWelcomeMsg: false,
                    },
                ]);
            }
        }, DELETE_ANIMATION_MS);
    };

    socket.on('delete:parlay', callback);

    return () => {
        socket.off('delete:parlay', callback);
    };
};
